import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Button } from '@sopranodesign/pulse-components';

const FaqScope = ({ content }) => {
  return (
    <Button variant="inline" as={Link} to={`/faqs/${content.id}/questions`}>
      {content.name}
    </Button>
  );
};

FaqScope.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};

export default FaqScope;
